import React, { useState } from "react";
import { Dialog, DialogPanel, DialogTitle, DialogBackdrop } from "@headlessui/react";
import { XMarkIcon,CheckCircleIcon } from "@heroicons/react/20/solid";

const DrawerSignalementDocument = ({ isOpen = true, onClose, id_doc, nom_doc,onFetchSignalementSuccess }) => {
        //new composant 
        const [documentData, setDocumentData] = useState({ id_doc: null, nom_doc: null });
        const [successMessage, setSuccessMessage] = useState(false);
        console.log("args drawer signalement",id_doc)

    
    const closeDialogSignalement = () => {
        setDocumentData({ id_doc: null, nom_doc: null });
        onClose();
        //window.location.reload(true);
    };

    const sendToZapierSignalement = async (id_doc,messageSignalement) => {
        const zapierURL = "https://hooks.zapier.com/hooks/catch/7206204/22qx11j/"; // 👈 Specify your Zapier Webhook URL here
        try {
            const response = await fetch(zapierURL, {
                method: "POST",
                mode: "cors",
                body: JSON.stringify({ id_doc, nom_doc, messageSignalement })
            });
            
        } catch (e) {
            console.log(e);
        }
    };

    const handleSubmitSignalement = (event) => {
        event.preventDefault();
        const messageSignalement = event.target.descriptionAnomalie.value;
        
        // on change le statut du document
        const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/document/${id_doc}`;
        fetch(
            URL,
            {
                method: "PATCH",
                headers: {
                    Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                    "Accept": "application/json",
                    'content-type': "application/json"
                },
                body: JSON.stringify({
                    "fields": {
                        "etat": "anomalie",
                        "message_signalement": messageSignalement, //envoyer dans le mail zapier c tout
                        document: [],// ✅ supprime les pièces jointes du champ "document"
                    }
                })
            }).then((res) => res.json());

        sendToZapierSignalement(id_doc,messageSignalement);
        setSuccessMessage(true);
        setTimeout(() => {
            closeDialogSignalement();
            onFetchSignalementSuccess();
        }, 2000);
    };

 
    return (
        <>
        <Dialog 
        className={`relative inset-0 z-10 flex justify-end bg-black bg-opacity-50 transition-opacity ${
            isOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
        open={isOpen} onClose={onClose} >
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
                />
                <div className="fixed inset-0" />

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                            <DialogPanel
                                transition
                                className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                            >
                                <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                    <div className="px-4 sm:px-6">
                                        <div className="flex items-start justify-between">
                                            <DialogTitle className="text-base font-semibold text-gray-900">Signaler ce document</DialogTitle>
                                            <div className="ml-3 flex h-7 items-center">
                                                <button
                                                    type="button"
                                                    onClick={onClose}
                                                    className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                                >
                                                    <span className="absolute -inset-2.5" />
                                                    <span className="sr-only">fermer</span>
                                                    <XMarkIcon aria-hidden="true" className="size-6" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                        
                                    {successMessage &&
                                        <>
                                        <div className=" flex flex-row items-center gap-2 justify-center text-emerald-800">
                                            <CheckCircleIcon className="w-8  size-12"/>
                                            <p>Document signalé</p>
                                        </div>
                                        </>
                                        }
                                        <div className="rounded-md bg-slate-50 p-4 mb-3">
                                <div className="flex">
                                    <div className="ml-3 flex-1 md:flex md:justify-between">
                                        <p className="text-sm text-slate-700">Nous allons informer les utilisateurs que ce document ne convient pas.</p>
                                    </div>
                                </div>
                            </div>
                                        <form onSubmit={handleSubmitSignalement}>
                                            <label className="block text-base font-medium text-gray-900"> </label>
                                            <textarea
                                                required
                                                name="descriptionAnomalie"
                                                rows={4}
                                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                placeholder="Décrivez ce qui ne convient pas dans ce document. C'est cette description que lira votre client."
                                            />
                                            <button
                                                type="submit"
                                                className="btn-primary mt-4"
                                            >
                                                Envoyer
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default DrawerSignalementDocument;